import * as React from "react"
import { motion } from "motion/react"

import { cn } from "@/lib/utils/index"

export interface ShineBorderProps {
  /**
   * Width of the border in pixels
   * @default 1
   */
  borderWidth?: number
  /**
   * Duration of the animation in seconds
   * @default 14
   */
  duration?: number
  /**
   * Color of the border, can be a single color or an array of colors
   * @default "#000000"
   */
  shineColor?: string | string[]
  className?: string
  style?: React.CSSProperties
}

/**
 * Shine Border
 *
 * An animated background border effect component with configurable properties.
 */
export function ShineBorder({
  borderWidth = 1,
  duration = 14,
  shineColor = "#000000",
  className,
  style,
}: ShineBorderProps) {
  const shineGradient = Array.isArray(shineColor)
    ? shineColor.join(",")
    : `${shineColor}, ${shineColor}`

  return (
    <motion.div
      style={
        {
          border: `${borderWidth}px solid transparent`,
          backgroundImage: `linear-gradient(var(--card), var(--card)), linear-gradient(130deg, transparent 16%, ${shineGradient}, transparent 84%)`,
          backgroundSize: "100% 100%, 260% 260%",
          backgroundPosition: "center, 0% 0%",
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          ...style,
        } as React.CSSProperties
      }
      animate={{ backgroundPosition: ["center, 0% 0%", "center, 100% 100%", "center, 0% 0%"] }}
      transition={{ duration, ease: "linear", repeat: Infinity }}
      className={cn(
        "pointer-events-none absolute inset-0 size-full rounded-[inherit] will-change-[background-position]",
        className
      )}
    />
  )
}
